import React from 'react'
import DhonusdhariStartingComponent from './DhonusdhariStartingComponent.jsx'
import AboutDhonus from './AboutDhonus.jsx'
import "./Home_main.css"
import Our_division from './Our_division.jsx'
import ContactUs from "./ContactUs.jsx"
import Footer from "../Footer.jsx"
import Navber from  "./Navbar.jsx"

function Home_main() {
  return (
    <div className='home_main'>
        <DhonusdhariStartingComponent/>
        {/* <Navber/> */}
        <AboutDhonus/>
        <Our_division/>
        <ContactUs/>
        <Footer/>
    </div>
  )
}

export default Home_main